import React from 'react'
import { Wrapper } from 'src/ui/layout'
import { BLOCK_DATA } from './constants'
import { styled, useTheme } from 'src/ui/theme'
import { Body, Header } from 'src/ui/typography'
import { Icons } from 'src/ui/icons'
import { breakpoints } from 'src/ui/dimensions'

const BlocksContainer = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1.2fr 3fr;
  gap: 50px;
  width: 100%;

  box-sizing: border-box;

  @media (max-width: ${breakpoints.desktopXS}px) {
    grid-template-columns: repeat(2, 1fr);

    & > :last-child {
      grid-column: span 2;
    }
  }

  @media (max-width: ${breakpoints.tabletXS}px) {
    grid-template-columns: 1fr;
    gap: 30px;

    & > :last-child {
      grid-column: span 1;
    }
  }
`

const Block = styled.div<{ isLast?: boolean }>`
  position: relative;
  height: 216px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 32px;

  background-color: ${({ isLast, theme }) =>
    isLast ? theme.colors.brand.primary : theme.colors.gray.bg};
`

const Icon = styled.div`
  position: absolute;
  top: 32px;
  right: 32px;
  bottom: 32px;
`

export const Blocks = () => {
  const theme = useTheme()
  return (
    <Wrapper>
      <BlocksContainer>
        {BLOCK_DATA.map((item, index) => (
          <Block isLast={index === BLOCK_DATA.length - 1}>
            <Header
              as="h1"
              size="h1"
              color={
                index === BLOCK_DATA.length - 1
                  ? theme.colors.white.primary
                  : theme.colors.brand.primary
              }
            >
              {item.title}
            </Header>
            <Body
              color={
                index === BLOCK_DATA.length - 1
                  ? theme.colors.white.primary
                  : theme.colors.black.secondary
              }
            >
              {item.body}
            </Body>
            {index === BLOCK_DATA.length - 1 && (
              <Icon>
                <Icons.HandWithHeart />
              </Icon>
            )}
          </Block>
        ))}
      </BlocksContainer>
    </Wrapper>
  )
}
